var chunkToChildrenMap = {
	"4242": [
		5244,
		4012,
		6161,
		4610,
		4886
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));